import React from "react";
import { ArticleAuthor } from "../types";
import { getInitials } from "../utils";

type AuthorInfoProps = {
  author: ArticleAuthor;
  subtitle?: string;
  variant?: "detail" | "compact";
};

const AuthorInfo = ({
  author,
  subtitle,
  variant = "detail",
}: AuthorInfoProps) => {
  const hasImage = Boolean(author?.profileImage);

  return (
    <div
      className={`author-info ${variant === "compact" ? "compact" : "centered"}`}
    >
      {hasImage ? (
        <img
          src={author.profileImage}
          alt={author.name}
          className="author-avatar"
        />
      ) : (
        <span className="author-avatar-fallback" aria-hidden="true">
          {getInitials(author?.name)}
        </span>
      )}
      <div className="author-meta">
        <span className="author-name">{author?.name}</span>
        {subtitle ? <span className="author-submeta">{subtitle}</span> : null}
      </div>
    </div>
  );
};

export default AuthorInfo;
